import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../redux/authSlice";
import { authAxios } from "../../utils/axiosConfig";
import {
	BookUser,
	CircleUser,
	FolderHeart,
	LogOut,
	UserPlus,
} from "lucide-react";
import { ROUTES } from "../../router/appRoutes";

const SideBarFull = () => {
	const { role } = useSelector((state) => state.auth);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleLogout = async (e) => {
		e.preventDefault();
		const response = await authAxios.post("/auth/logout");
		// console.log(response);
		await dispatch(logout());
		navigate(ROUTES.LOGIN);
	};

	return (
		<>
			<Link to={ROUTES.DASHBOARD} className="dashboard_menu_item">
				<CircleUser
					width={32}
					className="sidebar_menu_icon"
				/>
				<span className="sidebar_menu_name">Profile</span>
			</Link>
			<Link to={ROUTES.DASHBOARD_PROJECTS} className="dashboard_menu_item">
				<FolderHeart
					width={32}
					className="sidebar_menu_icon"
				/>
				<span className="sidebar_menu_name">Projects</span>
			</Link>
			{role === "admin" && (
				<>
					<Link to={ROUTES.DASHBOARD_USERS} className="dashboard_menu_item">
						<BookUser
							width={32}
							className="sidebar_menu_icon"
						/>
						<span className="sidebar_menu_name">User list</span>
					</Link>
					<Link
						to={ROUTES.DASHBOARD_USERS_ADD}
						className="dashboard_logout_btn dashboard_menu_item"
					>
						<UserPlus
							width={32}
							className="sidebar_menu_icon"
						/>
						<span className="sidebar_menu_name">Add user</span>
					</Link>
				</>
			)}

			<Link
				onClick={handleLogout}
				className="dashboard_logout_btn dashboard_menu_item"
			>
				<LogOut
					width={32}
					className="sidebar_menu_icon"
				/>
				<span className="sidebar_menu_name">Log out</span>
			</Link>
		</>
	);
};

export default SideBarFull;
